export default __webpack_public_path__ + "static/media/success.385fd575.svg";